import React from "react";

import PropTypes from "prop-types";

import { Skype, Mail, COLOR } from "@propellerads/icon";

import Translate from "Components/Translate";

import "./style.scss";

const ManagerInfoDetails = ({ name, avatar, email, skype }) => {
  return (
    <div className="ManagersInfo__wrapper">
      <div className="ManagersInfo__person">
        <div className="ManagersInfo__person-post">
          <Translate tag="manager-info-details-name" />
        </div>
        <div className="ManagersInfo__person-name">{name}</div>
        <img
          className="ManagersInfo__person-avatar"
          src={avatar}
          alt="Manager's avatar"
        />
      </div>
      <div className="ManagersInfo__info">
        {skype && (
          <div className="ManagersInfo__item">
            <Skype color={COLOR.BLUE} classNames="ManagersInfo__item-icon" />
            <a
              className="ManagersInfo__item-link"
              href={`skype:${skype}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {skype}
            </a>
          </div>
        )}
        {email && (
          <div className="ManagersInfo__item">
            <Mail classNames="ManagersInfo__item-icon" />
            <a
              className="ManagersInfo__item-link"
              href={`mailto:${email}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {email}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

ManagerInfoDetails.propTypes = {
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  email: PropTypes.string,
  skype: PropTypes.string,
};

ManagerInfoDetails.defaultProps = {
  email: null,
  skype: null,
};

export default ManagerInfoDetails;
